/**
 * Valida o formato de um email
 * @param email - O email a ser validado
 * @returns null se válido, string com erro se inválido
 */
const validateEmail = (email: string): string | null => {
  if (!email) {
    return "Email é obrigatório";
  }

  // Regex para validar formato de email
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (!emailPattern.test(email)) {
    return "Formato de email inválido. Use o formato: exemplo@dominio.com";
  }

  return null;
};

export default validateEmail;
